import React from "react";
import { Link } from "react-router-dom";
import { FileText, Lock, Shield, HelpCircle, Cookie, ChevronRight } from "lucide-react";
import LegalShell from "./LegalShell";

/**
 * /legal — directory landing page. Index for the legal corpus.
 */
export default function LegalIndexPage() {
  const items = [
    { to: "/legal/terms",   icon: FileText, title: "Terms of Service",
      desc: "Eligibility, the service, acceptable use, orders, refunds, liability." },
    { to: "/legal/privacy", icon: Lock,     title: "Privacy Policy",
      desc: "What we collect, why, how long we keep it, and your rights." },
    { to: "/legal/aml",     icon: Shield,   title: "AML / KYC Disclosure",
      desc: "Our anti-money-laundering framework and customer-due-diligence approach." },
    { to: "/legal/why-sof", icon: HelpCircle, title: "Why we ask for Source of Funds",
      desc: "Plain-language explainer for the SoF document request." },
    { to: "/legal/cookies", icon: Cookie,   title: "Cookie Notice",
      desc: "How we use cookies and similar technologies, and how you can control them." },
  ];
  return (
    <LegalShell title="Legal" testid="legal-index"
      intro={<>The full corpus of Xchangely's legal documentation. Updates are emailed at least 14 days before they take effect.</>}>
      <div className="grid sm:grid-cols-2 gap-3 not-prose mt-2">
        {items.map((x) => (
          <Link key={x.to} to={x.to}
                className="group rounded-xl border border-border bg-muted/20 p-4 hover:bg-muted/40 transition-colors flex gap-3 items-start"
                data-testid={`legal-index-${x.to.split("/").pop()}`}>
            <x.icon className="w-5 h-5 text-primary mt-1 shrink-0" />
            <div className="flex-1 min-w-0">
              <div className="font-display font-bold text-foreground flex items-center gap-1">
                {x.title}
                <ChevronRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
              <div className="text-xs text-muted-foreground mt-0.5 leading-relaxed">{x.desc}</div>
            </div>
          </Link>
        ))}
      </div>
    </LegalShell>
  );
}
